import { render } from "./ThreeComponent.vue?vue&type=template&id=61c96fa9"
import script from "./ThreeComponent.vue?vue&type=script&lang=js"
export * from "./ThreeComponent.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__